module.exports = __webpack_public_path__ + "img/icon-truck.690975ac.svg";